//Include Both Helper File with needed methods
import { call, put, takeEvery } from "redux-saga/effects";
import noticeFromTCTService from "services/NoticeFromTCTService";
import { getListRegistryDelegateFail } from "store/actions";
import { getListNoticeFromTCTSuccess } from "./actions";
// Crypto Redux States
import { GET_LIST_NOTICE_FROM_TCT } from "./actionTypes";

function* fetchGetListNoticeFromTCT({ params }) {
  try {
    // console.log("fetchGetListUpload");
    // console.log("params", params);
    // Param
    const perPage = params.sizePerPage;
    const page = params.page;
    const columnFilter = params.columnFilter;
    const keywords = params.keywords;
    const sort = params.sort;
    // Call api
    const response = yield call(
      noticeFromTCTService.listNotice,
      page,
      perPage,
      columnFilter,
      keywords,
      sort
    );
    const totalCount = response._meta.totalCount;
    // console.log("response", response);
    yield put(getListNoticeFromTCTSuccess(response.items, totalCount));
  } catch (error) {
    yield put(getListRegistryDelegateFail(error));
  }
}

function* noticeTCTSaga() {
  yield takeEvery(GET_LIST_NOTICE_FROM_TCT, fetchGetListNoticeFromTCT);
}

export default noticeTCTSaga;
